module.exports = __webpack_public_path__ + "img/failed.0d19b8ae.svg";